
"use client";

import type { ReactNode } from 'react';
// Use an alias if there's any concern about naming, though it's not strictly necessary here.
import { GoogleReCaptchaProvider as ActualReCaptchaProvider } from 'react-google-recaptcha-v3';

export default function ReCaptchaProviderWrapper({ children }: { children: ReactNode }) {
  const recaptchaSiteKey = process.env.NEXT_PUBLIC_RECAPTCHA_V3_SITE_KEY;

  if (!recaptchaSiteKey) {
    console.warn("ReCaptchaProviderWrapper: NEXT_PUBLIC_RECAPTCHA_V3_SITE_KEY is not set. reCAPTCHA will not be enabled.");
    // Render children without the provider if the key is missing,
    // so the rest of the app (like AuthProvider) can still function.
    return <>{children}</>;
  }

  return (
    <ActualReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
      {children}
    </ActualReCaptchaProvider>
  );
}
